import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';

import { breakPoints } from '~/src/constants/breakpoints';

import { Img, Title } from '~/src/features/center/BlockInfo/styled';

interface IGradient {
    bgGradient: string,
    needShadow: boolean,
}

export const Container = styled.div`
    width: calc(50% - 8px);
    height: 576px;
    background: radial-gradient(${(props: IGradient) => props.bgGradient}), ${COLORS.white};
    border-radius: 32px;
    margin-bottom: 16px;
    box-shadow: ${(props: IGradient) => props.needShadow ? '0 4px 16px 0 rgb(0 0 0 / 10%)' : 'initial'};

    @media (min-width: ${breakPoints.tablet}) and (max-width: ${breakPoints.desktop}) {
        height: 600px;
    }

    @media (max-width: 1278px) {
        width: 100%;
    }

    @media (min-width: 1278px) {
        &:nth-child(odd) {
            margin-right: 16px;
        }
    }

    @media (max-width: ${breakPoints.tablet}) {
       display: block;
    }

    &:nth-child(-n+5) ${Img} {
        @media (max-width: 470px) {
            margin-top: 35px;
            background-position: center;
            height: 160px;
        }
    }
    
    &:nth-child(3) ${Img} {
        @media (max-width: 470px) {
            margin-top: 15px;
        }
    }
    
    &:nth-child(5) ${Img} {
        @media (max-width: 470px) {
            margin-top: 15px;
        }
    }

    &:nth-child(1) ${Img} {
        @media (max-width: 470px) {
          margin-top: 15px;
        }
    }

    &:nth-child(4) ${Title} {
        @media (max-width: ${breakPoints.mobile}) {
            margin-top: 15px;
        }
    }

    &:nth-child(3) ${Img} {
        @media (max-width: 470px) {
          height: 215px;
        }
    }

    &:nth-last-child(-n+4) ${Img} {
        @media (min-width: ${breakPoints.tablet}) and (max-width: ${breakPoints.desktop}) {
            margin-top: -65px;
        }
    }
    
    &:nth-last-child(-n+2) ${Img} {
        @media (max-width: ${breakPoints.desktop}) {
            margin-top: -85px;
        }
        
        @media (max-width: ${breakPoints.tablet}) {
            margin-top: -50px;
        }

        @media (max-width: 330px) {
            background-size: contain;
        }
    }
`;
